import { getAxiosConfig } from '../apisSetup/apiConfig';
import { PATHS } from 'AppConstants';

const ccbAxiosApiCaller = getAxiosConfig(PATHS.CCB_URL, true, {
}, false);

export const getReasonsTriptags = (apidata = {}) => ccbAxiosApiCaller.get(PATHS.GET_TRIPTAGS_REASONS, { params: { ...apidata } });
export const saveTripFormData = (apidata = {}) => ccbAxiosApiCaller.put(PATHS.SAVE_TRIP_FORM_DATA, apidata);
